import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { apiGet } from '../../../services/apiFetch';
import '../../../styles/Teams.css';

const TeamRoster = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [team, setTeam] = useState(null);
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data: teamData, error: teamError } = await apiGet(`/api/rl/teams/${id}`);
                if (teamError) throw new Error(teamError.error);

                const { data: playersData, error: playersError } = await apiGet(`/api/rl/teams/${id}/players`);
                if (playersError) throw new Error(playersError.error);

                if (teamData) {
                    setTeam(teamData);
                }

                if (playersData) {
                    setPlayers(playersData);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching team data:", error);
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleBack = () => {
        navigate(-1);
    };

    if (loading) {
        return <div className="loading-spinner"></div>;
    }

    return (
        <div className="team-list-page">
            <button onClick={handleBack} className="admin-back-button">
                ← Back
            </button>
            <div className="page-header">
                <h1>{team?.name} Roster</h1>
                <div className="header-actions">
                    <Link to={`/admin/players/create?team=${id}`} className="create-button">
                        Add Player
                    </Link>
                </div>
            </div>

            {players.length === 0 ? (
                <div className="no-players">
                    <p>No players on this team</p>
                    <Link to={`/admin/players/create?team=${id}`} className="add-player-button">
                        Add Player
                    </Link>
                </div>
            ) : (
                <div className="admin-table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Player</th>
                                <th>Username</th>
                                <th>Country</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {players.map(player => (
                                <tr key={player.id}>
                                    <td>
                                        <div className="player-info">
                                            <img
                                                src={player.image}
                                                alt={player.username}
                                                className="player-avatar"
                                                onError={(e) => { e.target.src = '/assets/images/placeholder.png' }}
                                            />
                                            <span>{player.username}</span>
                                        </div>
                                    </td>
                                    <td>{player.dob}</td>
                                    <td>{player.country || '-'}</td>
                                    <td>
                                        <Link to={`/admin/players/edit/${player.id}`} className="create-button">
                                            Edit
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default TeamRoster;